var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocaleDeDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 8.25H23.25V15.75H0.75V8.25Z",
    fill: "#CC2B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3H20.25C21.906 3 23.25 4.344 23.25 6V9H0.75V6C0.75 4.344 2.094 3 3.75 3Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21L3.75 21C2.094 21 0.75 19.656 0.75 18V15L23.25 15V18C23.25 19.656 21.906 21 20.25 21Z",
    fill: "#F8D147"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocaleDeDe);
export default __webpack_public_path__ + "static/media/icon-locale-de-DE.665eebcfb959e757cdb3373ccc4f9898.svg";
export { ForwardRef as ReactComponent };